<template>
  <authorization permissionKey="attendance_therapy" can="read">
    <v-container fluid>
      <v-row align="center">
        <v-col class="text-h3 gray--text" cols="auto">
          Terapêuticas
        </v-col>

        <v-col cols="4">
          <AttendanceTherapyProtocolForm
            class="mr-4"
            :attendance="attendance"
            :attendanceEsigned="attendanceEsigned"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="attendance_therapy"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-col cols="auto" v-if="authorization">
              <v-btn
                color="light-blue"
                @click="showAttendanceTherapyForm = true"
                :dark="!attendanceEsigned"
                :disabled="attendanceEsigned"
              >
                Adicionar
              </v-btn>
            </v-col>
          </authorization>
        </v-col>
      </v-row>

      <AttendanceTherapyList
        :attendance="attendance"
        :allowEdit="!attendanceEsigned"
        :allowDelete="!attendanceEsigned"
      />

      <AttendanceTherapyForm
        :attendance="attendance"
        :showAttendanceTherapyForm="showAttendanceTherapyForm"
        :toggleShow="
          () => (showAttendanceTherapyForm = !showAttendanceTherapyForm)
        "
        :disabled="attendanceEsigned"
      />
    </v-container>
  </authorization>
</template>

<script>
import AttendanceTherapyProtocolForm from "@/components/attendance/therapy_protocol_form/index.vue";
import AttendanceTherapyList from "@/components/attendance_therapy/list/index.vue";
import AttendanceTherapyForm from "@/components/attendance_therapy/form/index.vue";

export default {
  name: "Nursing",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    AttendanceTherapyProtocolForm,
    AttendanceTherapyList,
    AttendanceTherapyForm,
  },
  data() {
    return {
      showAttendanceTherapyForm: false,
      template: "",
    };
  },
  apollo: {
    templates: {
      query: require("@/graphql/template/templates.gql"),
      variables() {
        return {
          templateType: "attendance_therapy",
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
